import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import Icon from '@bbkAdminComponents/icons/icon-generator';
import './styles/buttons.scss';

type Props = {
  title: React.ReactNode;
  openModal?: React.MouseEventHandler<HTMLButtonElement>;
};
export const ArrowButton: React.FC<Props> = ({ openModal, title }) => (
  <button
    className={cs('bbk-button', 'primary', 'arrowButton', 'brightPurple')}
    onClick={openModal}
  >
    <span className="text">{title}</span>
    <Icon name="arrow" />
  </button>
);
